export default "/react/logoAiUp-8b550c77.png";